// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RelayRuntime = require("relay-runtime");

let Types = {};

let fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function makeConnectionId(connectionParentDataId) {
  return RelayRuntime.ConnectionHandler.getConnectionID(connectionParentDataId, "DevelopmentUnitSearchResultCard__unitImages", undefined);
}

function getConnectionNodes(connection) {
  if (connection === undefined) {
    return [];
  }
  let edges = connection.edges;
  if (edges !== undefined) {
    return Stdlib_Array.filterMap(edges, edge => {
      if (edge !== undefined) {
        return edge.node;
      }
    });
  } else {
    return [];
  }
}

let Utils = {
  getConnectionNodes: getConnectionNodes
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__DevicePixelRatio"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "unitImages"
        ]
      }
    ]
  },
  "name": "DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nodeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentProject",
      "kind": "LinkedField",
      "name": "development",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "unitImages",
      "args": null,
      "concreteType": "DevelopmentProjectSampleUnitImageConnection",
      "kind": "LinkedField",
      "name": "__DevelopmentUnitSearchResultCard__unitImages_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DevelopmentProjectSampleUnitImageEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageAttachment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "crop",
                      "value": false
                    },
                    {
                      "kind": "Literal",
                      "name": "embed",
                      "value": true
                    },
                    {
                      "kind": "Literal",
                      "name": "height",
                      "value": 468
                    },
                    {
                      "kind": "Variable",
                      "name": "ratio",
                      "variableName": "__relay_internal__pv__DevicePixelRatio"
                    },
                    {
                      "kind": "Literal",
                      "name": "width",
                      "value": 648
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DevelopmentProjectSampleUnit",
  "abstractKey": null
};
})());

exports.Types = Types;
exports.Internal = Internal;
exports.makeConnectionId = makeConnectionId;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
